import { Button } from '@loomhq/lens';
import classNames from 'classnames';
import React, { useState } from 'react';

import { SHARE_MENU_ACTION_OPEN_MENU } from 'constants/events';
import * as analytics from 'utilities/analytics';

import ShareDropdownMenu from './index';

const SocialMediaShareButton = ({
  buttonElement,
  classes,
  currentUserIsOwner,
  dropdownMenuClasses,
  user,
  video,
}) => {
  const [socialMediaShareIsOpen, setSocialMediaShareIsOpen] = useState(false);

  const toggleShareDropdown = () => {
    // If currently closed, it will now open, so track it
    if (socialMediaShareIsOpen) {
      analytics.track(SHARE_MENU_ACTION_OPEN_MENU);
    }

    setSocialMediaShareIsOpen(!socialMediaShareIsOpen);
  };

  return (
    <div
      className={classNames(
        'relative ignore-react-onclickoutside-share',
        classes
      )}
    >
      {buttonElement ? (
        buttonElement(() => toggleShareDropdown())
      ) : (
        <Button onClick={() => toggleShareDropdown()}>Share</Button>
      )}

      <ShareDropdownMenu
        additionalClass={dropdownMenuClasses}
        align="right"
        vAlign="auto"
        outsideClickIgnoreClass="ignore-react-onclickoutside-share"
        onHide={() => setSocialMediaShareIsOpen(false)}
        show={socialMediaShareIsOpen}
        currentUserIsOwner={currentUserIsOwner}
        hasGmailAccount={user && user.has_gmail_account}
        video={video}
      />
    </div>
  );
};

export default SocialMediaShareButton;
